import type { LensType } from './order.js'

/** "+0.50", "-2.25", "0.00" (RxFormat.Signed). */
export function signed(v: number): string {
  const text = (Math.round(v * 100) / 100).toFixed(2)
  return v > 0 ? '+' + text : text === '-0.00' ? '0.00' : text
}

/** The choices on the form, after Single vision (null). */
export const OFFERED_LENS_TYPES = ['Progressive', 'Bifocal'] as const

/** The wording staff see on the form; the email uses the same words. */
export function lensLabel(t: LensType | null): string {
  if (t === null) return 'Single vision'
  if (t === 'Reading') return 'Reading only'
  return t
}
